export default __webpack_public_path__ + "static/media/relyon_us.7ed20327.png";